var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"setup":_vm.setup}},[_c('div',{staticClass:"main-content"},[_c('fin-form',{ref:"form",attrs:{"defaultData":_vm.defaultParam,"formData":_vm.formData,"backend":true,"theme":"light"},on:{"landChange":_vm.landChange,"reset":_vm.reset,"save":_vm.save}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }